import * as whatifTypes from './whatIfTypes';
import { api_getCalculations, api_downloadExcel, api_getCountriesDictionary } from 'src/services/whatif.service';
import { push } from 'connected-react-router';
import { WHAT_IF_RESULTS_URL } from 'src/constants/constants.js';
import moment from 'moment';
import { saveAs } from 'file-saver';

export const addEmployee = () => ({
  type: whatifTypes.ADD_EMPLOYEE,
});

export const setEmployeesFromCSV = employees => ({
  type: whatifTypes.SET_EMPLOYEES_FROM_CSV,
  employees,
});

export const removeSelectedEmployees = () => {
  return (dispatch, getState) => {
    let newEmployees = {};
    const { whatIf } = getState();

    Object.keys(whatIf.employees).forEach(empKey => {
      if (!whatIf.employees[empKey].selected) {
        newEmployees[empKey] = whatIf.employees[empKey];
      }
    });

    dispatch({
      type: whatifTypes.REMOVE_EMPLOYEES,
      newEmployees,
    });
  };
};

export const clearEmployees = () => {
  return dispatch => {
    dispatch({
      type: whatifTypes.CLEAR_EMPLOYEES,
    });
  };
};

export const setEmployeeValue = (id, attr, value) => ({
  type: whatifTypes.SET_EMPLOYEE_VALUE,
  id,
  attr,
  value,
});

export const setOutputCurrency = value => ({
  type: whatifTypes.SET_OUTPUT_CURRENCY,
  value,
});

export const getCalculations = (params, isUpdate) => {
  return async dispatch => {
    dispatch(setCalculationsLoading(true));
    const response = await api_getCalculations(params);
    if (response && !response.errors && !response.error) {
      let results = response.results;
      results.forEach(result => {
        result.totalCompensationWithEmployees = result.totalCompensation * result.numEmployees;
        result.key =
          result.hostCountry +
          result.homeCountry +
          result.totalCompensationWithEmployees +
          result.maritalStatus +
          result.duration +
          result.numEmployees;
      });
      dispatch(getCalculationsSuccess(results, Math.max(...results.map(o => o.totalCompensationWithEmployees), 0)));
      if (!isUpdate) {
        dispatch(setPageType('list'));
        dispatch(push(WHAT_IF_RESULTS_URL));
      }
    }
    dispatch(setCalculationsLoading(false));
  };
};

export const getCalculationsSuccess = (data, maxCompensation) => ({
  type: whatifTypes.GET_CALCULATIONS_SUCCESS,
  data,
  maxCompensation,
});

export const setCalculationsLoading = isLoading => ({
  type: whatifTypes.SET_LOADING_CALCULATIONS,
  isLoading,
});

export const setPageType = pageType => ({
  type: whatifTypes.SET_PAGETYPE,
  pageType,
});

export const selectResult = index => ({
  type: whatifTypes.SELECT_RESULT,
  index,
});

export const deleteSelected = index => ({
  type: whatifTypes.DELETE_SELECTED,
});

export const downloadExcel = params => {
  return async dispatch => {
    dispatch(setExcelDownloading(true));
    const response = await api_downloadExcel(params);
    if (response) {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const filename = 'WhatIfCalculations_' + moment().format('YYYY-MM-DD') + '.xlsm';
      saveAs(blob, filename);
    }
    dispatch(setExcelDownloading(false));
  };
};

export const setExcelDownloading = isLoading => ({
  type: whatifTypes.SET_LOADING_EXCEL_DOWNLOADING,
  isLoading,
});

export const setDetailIndex = index => ({
  type: whatifTypes.SET_DETAIL_INDEX,
  index,
});

export const getCountriesDictionary = () => {
  return async dispatch => {
    const response = await api_getCountriesDictionary();
    if (response && !response.error && !response.errors) {
      dispatch(getCountriesDictionarySuccess(response.countriesDictionary));
    }
  };
};

export const getCountriesDictionarySuccess = countriesDictionary => ({
  type: whatifTypes.GET_COUNTRIES_DICTIONARY_SUCCESS,
  countriesDictionary,
});
